import { Controller } from "@hotwired/stimulus"
import { animateWindowScroll, catalogScrollTop } from "../../lib/window_scroll"

const CATEGORY_SCROLL_DURATION = 350

export default class extends Controller {
  connect() {
    this.element.dataset.catalogFrameReady = "true"
    this.syncHeader()
  }

  disconnect() {
    this.cancelScroll?.()
    delete this.element.dataset.catalogFrameReady
    delete this.element.dataset.categoryScrollDuration
    delete this.element.dataset.categoryScrollComplete
  }

  prepareNavigation(event) {
    if (event.target !== this.element) return

    this.cancelScroll?.()
    const destination = new URL(event.detail.url)
    this.shouldScrollAfterLoad = destination.pathname !== window.location.pathname
    delete this.element.dataset.categoryScrollDuration
    delete this.element.dataset.categoryScrollComplete
  }

  catalogLoaded(event) {
    if (event.target !== this.element) return

    this.syncHeader()
    if (this.shouldScrollAfterLoad) this.scrollToCatalogTop()
    this.shouldScrollAfterLoad = false
  }

  syncHeader() {
    this.replaceHeaderContent("header-breadcrumb", this.element.querySelector("#content-products .breadcrumb"))
    this.replaceHeaderContent("header-filters", this.element.querySelector("#content-products #filters-bar"))
  }

  replaceHeaderContent(id, source) {
    const container = document.getElementById(id)
    if (!container || !source) return

    container.replaceChildren(source.cloneNode(true))
  }

  scrollToCatalogTop() {
    const sidebar = this.element.querySelector("#sidebar")
    const fixedSidebar = sidebar?.querySelector("#fixed")
    if (!sidebar || !fixedSidebar) return

    const top = catalogScrollTop(sidebar, fixedSidebar)
    if (window.scrollY <= top) {
      this.element.dataset.categoryScrollComplete = String(window.scrollY)
      return
    }

    this.element.dataset.categoryScrollDuration = String(CATEGORY_SCROLL_DURATION)
    this.cancelScroll = animateWindowScroll(top, {
      duration: CATEGORY_SCROLL_DURATION,
      onComplete: () => {
        this.cancelScroll = null
        this.element.dataset.categoryScrollComplete = String(window.scrollY)
      }
    })
  }
}
